import React from "react";
var __jsx = React.createElement;
import useBoolean from "@hooks/useBoolean";
//@ts-ignore

import { twMerge } from "tailwind-merge";
var ColorIndicators = function ColorIndicators(_ref) {
  var colors = _ref.colors;
  var _useBoolean = useBoolean(false),
    expandValue = _useBoolean.value,
    toggle = _useBoolean.toggle;
  var visibleColors = expandValue ? colors : colors.slice(0, 3);
  var remainingCount = (colors === null || colors === void 0 ? void 0 : colors.length) - visibleColors.length;
  return /*#__PURE__*/React.createElement("div", {
    className: twMerge("p-1 rounded-full bg-[#d6dfe980] flex items-center gap-1 font-bold"),
    onClick: function onClick() {
      return toggle();
    }
  }, remainingCount > 0 && !expandValue && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-center text-xs cursor-pointer text-gray-text ms-1 leading-3"
  }, remainingCount, "+"), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1",
    style: {
      direction: "ltr"
    }
  }, visibleColors.map(function (color, idx) {
    return /*#__PURE__*/React.createElement("div", {
      key: idx,
      className: "w-4 h-4 rounded-full bg-white border border-solid border-neutral-10",
      style: {
        backgroundColor: color.color_code
      }
    });
  })));
};
export default ColorIndicators;